// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__35P6c","footer":"ModalUpdate_footer__1ob5F"};